import {
  CcfFavoriteIcon,
  CcfTeamIcon,
  CcfTemplateIcon,
  CcfTypography,
  CcfUserstarIcon,
} from '@nice-ccf/ui-controls';
import ArchiveOutlinedIcon from '@mui/icons-material/ArchiveOutlined';

import styles from '../simulator-v2.module.scss';
import {
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Theme,
} from '@mui/material';
import { makeStyles } from '@mui/styles';
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { simulatorV2Actions } from '../+state/simulatorV2.slice';

const drawerWidth = window.innerWidth / 5;
const useStyles = makeStyles((theme: Theme) => ({
  root: {
    display: 'flex',
    opacity: '1',
    height: '100%',
    width: '100%',
    '& .MuiDrawer-paper': {
      position: 'relative',
      height: '100%',
    },
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
    whiteSpace: 'nowrap',
  },
  drawerOpen: {
    width: (drawerWidth / 10) * 9,

    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerClose: {
    width: '60px !important',
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    overflowX: 'hidden',
    [theme.breakpoints.up('sm')]: {
      width: theme.spacing(9) + 1,
    },
  },
  toolbar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    cursor: 'pointer',
    padding: theme.spacing(0, 1),
    minHeight: '36px',
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
  },
  summaryContent: {
    '&.MuiAccordionSummary-content': {
      margin: 0,
    },
  },
  expandIcon: {
    margin: 0,
    position: 'absolute',
    right: '0',
    marginRight: '15px',
    '&.Mui-expanded': {
      transform: 'rotate(180deg)',
    },
  },
  listRoot: {
    padding: 0,
    overflowY: 'hidden',
    overflowX: 'hidden',
    height: '100%',
  },
  listItemIconRoot: {
    display: 'flex !important',
    justifyContent: 'space-around !important',
  },
  menuListItemIconRoot: {
    display: 'flex !important',
    justifyContent: 'space-between !important',
    minWidth: '40px',
  },
  listItemIcon: {
    justifyContent: 'center',
  },
  popover: {
    pointerEvents: 'none',
  },
}));
/* eslint-disable-next-line */
export interface SimulatorV2LeftNavProps {
  selectedAction: any;
  setSelectedAction: any;
}
/**
 * New Simulator Component to mimic the Call/Post feature from different sources
 * * @param props - its will take the list of conatct , current selected conatct and the onclick handler method
 * @returns
 * @example
 */
export function SimulatorV2LeftNav(props: SimulatorV2LeftNavProps) {
  const dispatch = useDispatch();
  const { setSelectedAction } = props;
  const { setCreateNewJourney } = simulatorV2Actions;
  const classes = useStyles();
  const navigationItemsList = [
    'All Journeys',
    'Crafted By Me',
    'Favorites',
    'Archived',
    'Custom Workspace',
  ];

  /**
   * Function to handle drawer open close
   * @example renderIcon()
   */
  const renderIcon = (title: string) => {
    switch (title) {
      case 'All Journeys':
        return <CcfTeamIcon />;
      case 'Crafted By Me':
        return <CcfUserstarIcon />;
      case 'Favorites':
        return <CcfFavoriteIcon />;
      case 'Archived':
        return (
          <ArchiveOutlinedIcon
            style={{ fontSize: '1.8rem', color: '#3F5C69' }}
          />
        );
      case 'Custom Workspace':
        return <CcfTemplateIcon />;
      default:
        return <h1>No project match</h1>;
    }
  };
  const [navItems, setNavItems] = useState(navigationItemsList);
  const [selectedMenu, setSelectedMenu] = useState<null | any>(navItems[0]);
  /**@example */
  const selectedOptionHandler = (title: any) => {
    dispatch(setCreateNewJourney(false));
    setSelectedMenu(title);
    setSelectedAction(title);
  };
  return (
    <div>
      <CcfTypography className={styles.headerText}>View Journeys</CcfTypography>
      <List className={classes.listRoot}>
        {navItems.map((item, index) => (
          <div key={item}>
            <ListItem
              button
              key={item}
              style={{ padding: '5px 0px' }}
              selected={selectedMenu === item}
              onClick={() => selectedOptionHandler(item)}
            >
              <ListItemIcon className={classes.listItemIconRoot}>
                {renderIcon(item)}
              </ListItemIcon>
              <ListItemText
                primary={item}
                className={styles.listItemContainer}
              />
            </ListItem>
          </div>
        ))}
      </List>
    </div>
  );
}
export default SimulatorV2LeftNav;
